import * as yup from 'yup';
import { ERRORS } from 'utils/Errors';

export const EmailToOrderSchema = yup.object({
  receiver: yup.string().required(ERRORS.REQUIRED_FIELD),
  billingPlant: yup.string().required(ERRORS.REQUIRED_FIELD),
  orderType: yup.string().required(ERRORS.REQUIRED_FIELD)
});
